module.exports = __webpack_public_path__ + "static/media/clothes_title_en@3x.c74379dd.png";